/**
 * region for libraries*/
import React, { Component } from 'react';

/**
 * region for component*/
import { WorkingLayer } from '../../../../components/common/WorkingLayer';
import { Row } from './Row';
import Paginator from '../../../../components/common/Paginator';

/**
 * region for helpers*/
import ajax from '../../../../helpers/ajax';
import typing from '../../../../helpers/typing';

/**
 * region for constants*/
import Constants from '../../../../constants/Constants'



export class TableDashboard extends Component {
    static displayName = TableDashboard.name;

    constructor (props) {
        super(props);
        this.state = {
            mode: Constants.MODE_LOADING,
            rows: [],
            filters: { ...this.props.filters },
            totalCount: 0,
            currentPage: 1,
        };
   }

    load() {
        let page=(this.props.resetPage)?1:this.state.currentPage;
        this.loadContentOrganization(page);      

    }

    reload(){
        this.loadContentOrganization(this.state.currentPage);
    }

    loadContentOrganization(pageNumber){
        const self = this;
        let requestData = {
            pageNumber: pageNumber,
            pageSize: Constants.PAGE_SIZE,
            ...this.state.filters
        };

        ajax.get(Constants.ROUTE_API_CONTENTORGANIZATION,
            {
                requestData: requestData,
                success: function (response) {
                    self.setState({
                        mode: Constants.MODE_LOADED,
                        rows: response.data,
                        totalCount: response.totalCount
                    });
                }
            });
    }

    componentWillReceiveProps(nextProps) {
        if (!typing.areEqual(this.state.filters, nextProps.filters)) {
            let page=(nextProps.resetPage)?1:this.state.currentPage;
            this.setState({
                mode: Constants.MODE_LOADING,
                filters: { ...nextProps.filters },
                currentPage: page
            }, function () { this.load(); });
        }
    }

    componentDidMount() {
        this.load();
    }

    setCurrentPage(newCurrentPage) {
        this.setState({
            mode: Constants.MODE_LOADING,
            currentPage: newCurrentPage
        }, function () { this.reload(); });
    }

    handleShowDetailLayer(row) {
        const self = this;
        if (self.props.onShowDetailLayer) {
            self.props.onShowDetailLayer(row);    
        }
    }

    render() {
        if (this.state.mode === Constants.MODE_LOADING) {
            return <WorkingLayer />
        }
        return (
            <div>
                <div className="table-responsive">
                <table className="table">
                    <thead>
                    <tr>
                        <th>Date</th>
                        <th>User</th>
                        <th>Item</th>
                        <th>Before</th>
                        <th>After</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                        {this.state.rows.map(row =>
                            <Row row={row}
                                key={row.IDCONTENTORGANIZATIONLOG}
                                showDetailLayer={this.state.showDetailLayer}
                                onShowDetailLayer={this.handleShowDetailLayer.bind(this, row)} />)
                        }
                </tbody>

            </table>
            </div>
            <Paginator totalCount={this.state.totalCount} currentPage={this.state.currentPage} handleSetCurrentPage={this.setCurrentPage.bind(this)} />
        </div>
    );
  }
}
